export default "__VITE_ASSET__CkmtI2SP__"